// src/belediye/pages/personel/PersonelProfilPage.js
// FAZ-18 · E2 — Kişi Profili. Bölümler backend'den İZNE GÖRE gelir (efektif_izinler/
// gecmis → users.view; performans → personel.performance.view). Frontend gelen bölümü
// gösterir. Operasyonel atama = mevcut staff_app akışına 2. giriş noktası (yeni endpoint YOK).

// FAZ-23: Personel profili YALNIZ operasyonel (temel bilgi + rol/birim + performans).
// Hesap/güvenlik bölümleri (efektif izinler / login geçmişi / şifre sıfırlama)
// Kullanıcılar (Sistem Yönetimi > Kullanıcılar detay) tarafına TAŞINDI (leakage fix).
import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { ArrowLeftIcon, ClipboardDocumentListIcon } from "@heroicons/react/24/outline";

import usePermissions from "../../hooks/usePermissions";
import { fetchPersonelProfil } from "../../services/personelApi";
import "./Personel.css";

export default function PersonelProfilPage() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { can } = usePermissions();
  const canAssign = can("assignments.create");

  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      setP(await fetchPersonelProfil(userId));
    } catch (ex) {
      setError(
        ex?.response?.status === 404
          ? "Bu personel kapsamınızda değil."
          : "Profil yüklenemedi."
      );
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    load();
  }, [load]);

  if (loading)
    return <div className="page-container ppf-root"><div className="pdz-state">Yükleniyor…</div></div>;
  if (error)
    return (
      <div className="page-container ppf-root">
        <div className="pdz-state pdz-state-error">
          {error}{" "}
          <button className="btn-md btn-md-ghost" onClick={load}>Tekrar dene</button>
        </div>
      </div>
    );

  const perf = p.performans;

  return (
    <div className="page-container ppf-root">
      <Link to="/yonetim/personel" className="ppf-back">
        <ArrowLeftIcon width={18} height={18} /> Personel
      </Link>

      {/* Genel bilgi */}
      <header className="md-card ppf-profile">
        <div className="ppf-avatar" aria-hidden="true">
          {(p.ad || p.username || "?").slice(0, 1).toLocaleUpperCase("tr")}
        </div>
        <div className="ppf-info">
          <h1 className="ppf-name">{p.ad}</h1>
          <div className="ppf-meta">
            <span>@{p.username}</span>
            {p.phone_number && <span>{p.phone_number}</span>}
            {p.is_superuser && <span className="md-chip md-chip-danger">Süper kullanıcı</span>}
          </div>
        </div>
        {canAssign && (
          <button
            className="btn-md btn-md-outline ppf-assign-btn"
            title="Mevcut atama akışına git"
            onClick={() => navigate("/yonetim/basvurular")}
          >
            <ClipboardDocumentListIcon width={18} height={18} /> Başvuru ata
          </button>
        )}
      </header>

      {/* Rol / birim (salt-okunur) */}
      <section className="md-card">
        <div className="md-card-header">
          <h2 className="md-card-title">Rol ve birimler</h2>
        </div>
        <div className="ppf-role">
          <span className="ppf-label">Global rol:</span>
          <span>{p.global_rol || "—"}</span>
        </div>
        {(!p.birimler || p.birimler.length === 0) ? (
          <div className="pdz-empty-inline">Birim ataması yok.</div>
        ) : (
          <ul className="ppf-units">
            {p.birimler.map((b, i) => (
              <li key={i} className="ppf-unit-row">
                <span className="ppf-unit-name">{b.unit_adi}</span>
                <span className="md-chip">{b.rol || "Rol yok"}</span>
                <span className={`md-chip ${b.aktif ? "md-chip-success" : "md-chip-danger"}`}>
                  {b.aktif ? "Aktif" : "Pasif"}
                </span>
              </li>
            ))}
          </ul>
        )}
      </section>

      {/* FAZ-23: "Yönetim / Şifre sıfırla" bölümü Kullanıcılar'a taşındı. */}

      {/* Performans özeti (türetilmiş) — personel.performance.view */}
      {perf && (
        <section className="md-card">
          <div className="md-card-header">
            <h2 className="md-card-title">Performans özeti</h2>
          </div>
          <div className="ppf-metrics">
            <Metric label="Atanan" value={perf.atanan} />
            <Metric label="Çözülen" value={perf.cozulen} />
            <Metric label="Aktif yük" value={perf.aktif_yuk} />
            <Metric
              label="Ort. çözüm"
              value={perf.ortalama_cozum_saat != null ? `${perf.ortalama_cozum_saat} sa` : "—"}
            />
          </div>
        </section>
      )}

      {/* FAZ-23: "Geçmiş/log" ve "Efektif izinler" bölümleri Kullanıcılar'a taşındı
          (hesap/güvenlik verisi; users.* gate'li). Personel yalnız operasyonel. */}

      {/* FAZ-23b — Atama geçmişi (backend gate: personel.profile.assignments.view) */}
      {p.atama_gecmisi && (
        <section className="md-card">
          <div className="md-card-header"><h2 className="md-card-title">Atama geçmişi</h2></div>
          {p.atama_gecmisi.length === 0 ? (
            <div className="pdz-empty-inline">Atama kaydı yok.</div>
          ) : (
            <ul className="ppf-list">
              {p.atama_gecmisi.map((a, i) => (
                <li key={i} className="ppf-list-row">
                  <span className="ppf-list-main">{a.basvuru_no || "—"} · {a.konu || ""}</span>
                  <span className="ppf-list-meta">{a.atayan || "—"} · {fmtT(a.tarih)}</span>
                </li>
              ))}
            </ul>
          )}
        </section>
      )}

      {/* FAZ-23b — İşlenen başvurular (backend gate: personel.profile.applications.view) */}
      {p.islenen_basvurular && (
        <section className="md-card">
          <div className="md-card-header"><h2 className="md-card-title">İşlenen başvurular</h2></div>
          {p.islenen_basvurular.length === 0 ? (
            <div className="pdz-empty-inline">Başvuru kaydı yok.</div>
          ) : (
            <ul className="ppf-list">
              {p.islenen_basvurular.map((b, i) => (
                <li key={i} className="ppf-list-row">
                  <span className="ppf-list-main">{b.basvuru_no} · {b.konu}</span>
                  <span className="ppf-list-meta">
                    <span className="md-chip">{b.durum}</span> {b.birim || ""} · {fmtT(b.tarih)}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </section>
      )}
    </div>
  );
}

const fmtT = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("tr-TR", { dateStyle: "medium" });
  } catch {
    return s;
  }
};

function Metric({ label, value }) {
  return (
    <div className="ppf-metric">
      <span className="ppf-metric-value">{value ?? 0}</span>
      <span className="ppf-metric-label">{label}</span>
    </div>
  );
}
